import { FRAME_RESOURCE_KEYS, LOCALE_SELECT_RESOURCE_KEYS } from "@com.mgmtp.a12.client/client-core/lib/core/frame";
import { LOCALE_RESOURCE_KEYS } from "@com.mgmtp.a12.client/client-core/lib/core/locale";
import { DIRTY_HANDLING_RESOURCE_KEYS } from "@com.mgmtp.a12.client/client-core/lib/extensions/dirtyHandling";
import { HETEROGENEITY_RESOURCE_KEYS } from "@com.mgmtp.a12.client/client-core/lib/extensions/heterogeneity";
import { CRUD_RESOURCE_KEYS } from "@com.mgmtp.a12.crud/crud-core";
import { RESOURCE_KEYS as FORMENGINE_RESOURCE_KEYS } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/localization";
import { RESOURCE_KEYS as OVERVIEWENGINE_RESOURCE_KEYS } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/services/localization";
import {
	CDM_RESOURCE_KEYS,
	RELATIONSHIP_RESOURCE_KEYS
} from "@com.mgmtp.a12.relationshipengine/relationshipengine-core";
import { RESOURCE_KEYS as TREEENGINE_RESOURCE_KEYS } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/core/services/localization";
import { initializeKeys } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

export const RESOURCE_KEYS = {
	application: {
		header: {
			banner: {
				stage: "",
				preview: ""
			},
			info: {
				title: "",
				version: { label: "" },
				accessibility: { label: "" },
				documents: {
					label: "",
					accessibilityLabel: ""
				}
			},
			title: {
				backToDashboard: "",
				reload: ""
			}
		},
		view: {
			accessibility: {
				title: "",
				buttons: { close: { title: "" } }
			},
			roles: {
				title: "",
				column: {
					type: { title: "" },
					name: { label: "" },
					baseRole: { label: "" },
					client: { label: "" }
				},
				role: {
					unknown: "",
					leiter: "",
					sachbearbeiter: "",
					sachbearbeiter_erweitert: "",
					betrachter: ""
				},
				buttons: { close: { title: "" } }
			}
		},
		content: {
			logout: {
				label: "",
				button: {
					label: ""
				}
			},
			noPublications: {
				label: "",
				content: ""
			},
			noAccess: {
				label: "",
				content: ""
			}
		},
		brand: "",
		titleParts: {
			prefix: "",
			main: ""
		}
	},
	resources: {
		"attachment-handler": {
			error: {
				unknown: "",
				unacceptableExtension: "",
				internal: "",
				abort: "",
				"not-found": "",
				security: "",
				"no-preview": "",
				"invalid-file": "",
				"no-handler": ""
			}
		}
	},
	error: {
		INTERNAL_CLIENT_ERROR: "",
		VALIDATION_ERROR: "",
		PAGE_NOT_FOUND_ERROR: "",
		SAVING_FAILED_ERROR: "",
		HTTP_ERROR: "",
		UNKNOWN_ERROR: "",
		FILE_INVALID_MESSAGE_ERROR: "",
		GENERATE_DOCUMENT_ERROR: "",
		GENERATE_DOCUMENT_WITH_CAUSE_ERROR: "",
		SIGN_DOCUMENT_WITH_CAUSE_ERROR: "",
		SIGN_USER_NOT_READY_ERROR: "",
		SIGN_STATUS_PENDING: "",
		SIGN_TRANSACTION_EXPIRED: "",
		DOWNLOAD_SIGNED_DOCUMENT_ERROR: "",
		SEND_EMAIL_ERROR: "",
		UNKNOWN_MESSAGE_ERROR: "",
		UNEXPECTED_ERROR: ""
	},
	externalEnumeration: {
		EmailBetreff: {
			0: {
				label: ""
			},
			1: {
				label: ""
			}
		}
	},
	features: {
		stammdaten: {
			notification: {
				extract: {
					success: {
						title: "",
						message: "",
						button: {
							label: ""
						}
					},
					error: {
						title: "",
						message: "",
						button: {
							label: ""
						}
					},
					warning: {
						title: "",
						message: ""
					}
				}
			},
			footer: {
				overview: ""
			}
		},
		button: {
			disabledReason: ""
		},
		control: {
			strikethroughHint: ""
		},
		zahlungsvorgangEpaybl: {
			error: {
				missingValue: "",
				requestFailed: "",
				saveFailed: "",
				unbekannt: ""
			},
			disabledReason: {
				create: "",
				status: ""
			},
			hint: {
				wirdAngelegtFuer: "",
				wurdeAngelegtFuer: ""
			},
			success: {
				statusUpdated: ""
			}
		},
		externalEnumeration: {
			contactList: {
				warning: ""
			}
		},
		wiedervorlagen: {
			dueCount: {
				single: "",
				multiple: ""
			}
		},
		notification: {
			title: {
				info: "",
				error: "",
				success: "",
				warning: ""
			},
			info: {
				exportCsv: ""
			},
			success: {
				exportCsv: "",
				newAntrag: "",
				eldorado: {
					generating: "",
					transmitting: ""
				},
				processLinking: {
					createdLinkedProcess: ""
				}
			},
			error: {
				textbausteine: {
					openModal: "",
					export: "",
					import: "",
					invalidImportFile: ""
				},
				assignWiedervorlage: "",
				assignStammdaten: "",
				wiedervorlagenErledigt: "",
				unexpectedError: "",
				environmentData: "",
				archive: "",
				exportCsv: {
					serverError: "",
					queueFull: ""
				},
				email: {
					missingAttachment: "",
					missingEmpfaenger: "",
					missingBetreff: "",
					missingMessage: "",
					malformedEmailAddress: "",
					technicalError: "",
					validationFailed: ""
				},
				gatewayEntscheidung: "",
				duplicateProcess: "",
				eldorado: {
					generatingError: "",
					generatingErrorWithCause: "",
					authenticationError: "",
					lockedError: "",
					conflictError: "",
					transmittingError: "",
					transmittingErrorWithCause: "",
					metadataErrorWithCause: "",
					cancellationError: "",
					missingFeldError: ""
				},
				xakte: {
					generatingError: "",
					generatingErrorWithCause: "",
					transmittingError: "",
					transmittingErrorWithCause: "",
					metadataError: "",
					metadataErrorWithCause: ""
				},
				assigneeCandidates: {
					genericError: ""
				},
				process: {
					unauthorized: ""
				},
				processLinking: {
					creatingLinkedProcessFailed: ""
				}
			},
			warning: {
				eldorado: {
					excludedAttachments: "",
					excludedMsgAttachments: "",
					docConversion: "",
					duplicatedItemTexts: ""
				},
				duplicateProcess: {
					removedFields: ""
				}
			},
			content: ""
		},
		popUpMenu: {
			expandAll: {
				openTitle: "",
				closeTitle: ""
			}
		},
		modals: {
			title: {
				loeschenModal: "",
				emailConfirmModal: ""
			},
			content: {
				loeschenModal: "",
				emailConfirmModal: "",
				emailConfirmModalSicher: ""
			},
			button: {
				abbrechen: "",
				abbrechenUndZurueck: "",
				loeschen: "",
				bestaetigen: "",
				close: ""
			},
			eldorado: {
				veraktenTitle: "",
				veraktenButton: "",
				generalDescription: "",
				antragsdatenDescription: "",
				prozessdatenDescription: "",
				additionalDescription: "",
				documentSelectionTitle: "",
				documentSelectionDefaultText: "",
				aktenkennzeichenTitle: "",
				mappenNummerTitle: "",
				betreffTitle: "",
				absenderTitle: "",
				bezugTitle: "",
				dokumentenArtTitle: "",
				papierformTitle: "",
				generateButton: "",
				generateAgainButton: "",
				previewTitle: "",
				previewDownloadLinkTitle: "",
				forceCancelModalTitle: "",
				forceCancelModalText: ""
			}
		},
		deleteProcess: {
			title: "",
			content: {
				createdAutomatically: "",
				createdManually: ""
			},
			button: "",
			cancel: "",
			error: ""
		},
		zugehoerigkeit: {
			title: "",
			info: "",
			button: "",
			cancel: "",
			error: ""
		},
		postfach: {
			error: {
				missingInboxReference: "",
				missingInboxReferenceLabel: "",
				toManyFiles: ""
			},
			helper: {
				attachments: ""
			},
			info: {
				attachments: ""
			}
		},
		buchungsassistent: {
			error: {
				missingValue: "",
				internalServerError: "",
				invalidFile: ""
			}
		},
		xFinanzDatei: {
			error: {
				missingValue: "",
				internalServerError: "",
				deleteError: ""
			}
		}
	},
	component: {
		toast: {
			header: {
				success: "",
				info: "",
				warning: "",
				error: ""
			}
		},
		autocomplete: {
			hintTemplate: ""
		},
		input: {
			clientSelection: {
				label: ""
			}
		},
		button: {
			apply: { label: "" },
			save: { label: "" },
			close: { label: "" },
			cancel: { label: "" }
		},
		modal: {
			general: {
				button: {
					close: { title: "" }
				}
			},
			logout: {
				title: "",
				message: "",
				caution: "",
				button: {
					cancel: { label: "" },
					logout: { label: "" }
				}
			},
			client: {
				title: { new: "" },
				button: {
					confirm: { new: { label: "" } }
				}
			}
		}
	},
	wf: {
		general: {
			actions: {
				cancel: "",
				start: ""
			}
		},
		sidemenu: {
			startProcess: {
				label: ""
			},
			mytasks: {
				label: ""
			},
			availabletasks: {
				label: ""
			},
			alltasks: {
				label: ""
			},
			completedprocesses: {
				label: ""
			}
		},
		startprocess: {
			title: "",
			dropdown: {
				title: ""
			},
			selecteddocuments: {
				id: "",
				type: "",
				name: "",
				unselect: ""
			}
		},
		notification: {
			success: {
				startprocess: ""
			},
			error: {
				startprocess: "",
				outdatedProcessVersion: {
					message: "",
					title: ""
				},
				stammdatenVersion: {
					title: "",
					message: ""
				},
				updatetask: "",
				completetask: "",
				completetaskFailed: "",
				gatewayTimeout: "",
				gatewayTimeoutRetry: "",
				taskPermission: "",
				assigntask: "",
				assigntask_archival: "",
				assigntask_archival_title: "",
				showdiagram: "",
				validationFailedTitle: "",
				validationFailedMessage: "",
				savingFailedTitle: "",
				lockProcessErrorTitle: "",
				savingFailedMessage: "",
				lockProcessErrorMessage: "",
				conflictedSavingMessage: "",
				createDocumentTitle: "",
				createDocumentMessage: ""
			}
		}
	},
	general: {
		indication: {
			info: "",
			success: "",
			important: "",
			caution: "",
			warning: "",
			error: ""
		}
	}
};

initializeKeys(RESOURCE_KEYS);

type DeepPartial<T> = T extends object ? { [P in keyof T]?: DeepPartial<T[P]> } : T;

export type LocalizationKeyTreeType = typeof RESOURCE_KEYS &
	DeepPartial<typeof CDM_RESOURCE_KEYS> &
	DeepPartial<typeof CRUD_RESOURCE_KEYS> &
	DeepPartial<typeof DIRTY_HANDLING_RESOURCE_KEYS> &
	DeepPartial<typeof FRAME_RESOURCE_KEYS> &
	DeepPartial<typeof HETEROGENEITY_RESOURCE_KEYS> &
	DeepPartial<typeof LOCALE_RESOURCE_KEYS> &
	DeepPartial<typeof LOCALE_SELECT_RESOURCE_KEYS> &
	DeepPartial<typeof RELATIONSHIP_RESOURCE_KEYS> &
	DeepPartial<typeof TREEENGINE_RESOURCE_KEYS> &
	DeepPartial<typeof FORMENGINE_RESOURCE_KEYS> &
	DeepPartial<typeof OVERVIEWENGINE_RESOURCE_KEYS>;
